<p-tabView>
  <p-tabPanel header="Recurso de Segurança">
    <fieldset>
      <div class="p-fluid">
        <div class="p-field p-grid">
          <label for="id" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Id:</label>
          <div class="p-col-12 p-md-10">
            <input pInputText type="text" name="id" disabled readonly [ngModel]="entidade.id" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label for="nome" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" [ngClass]="{'error' : invalid.nome && submit}">Nome:</label>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="nome" [(ngModel)]="entidade.nome" />
          </div>
        </div>

        <div class="p-grid">
          <div class="p-col-12 p-lg-2">
            <label for="dominio">Dominio:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <p-selectButton [options]="dominioItens" [(ngModel)]="entidade.dominio"></p-selectButton>
          </div>
        </div>
        <div class="p-grid" *ngIf="entidade.dominio == 'BACKEND'">
          <div class="p-col-12 p-lg-2">
            <label for="metodo">Método:</label>
          </div>
          <div class="p-col-12 p-lg-10">
            <p-selectButton [options]="metodoItens" [(ngModel)]="entidade.metodo"></p-selectButton>
          </div>
        </div>

        <div class="p-field p-grid">
          <label for="autenticacao" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Requer Autenticação?</label>
          <div class="p-col-12 p-md-10">
            <p-checkbox [(ngModel)]="entidade.requerAutenticacao" binary="true"></p-checkbox>
          </div>
        </div>
      </div>
    </fieldset>
    <br />
    <fieldset>
      <legend class="p-fildset-title">Dados do Perfil</legend>
      <div class="p-fluid">
        <p-pickList
          [source]="perfilRecursosSeguranca"
          [target]="entidade?.perfis" [responsive]="true"
          [sourceStyle]="{'height':'300px'}"
          [targetStyle]="{'height':'300px'}"
          filterBy="perfil.nome">
          <ng-template let-perfilRecursoSeguranca pTemplate="item">
            <div class="p-helper-clearfix p-text-break">
              {{perfilRecursoSeguranca.perfil.nome}}
            </div>
          </ng-template>
        </p-pickList>
      </div>
    </fieldset>
  </p-tabPanel>
  <p-tabPanel header="Auditoria" [disabled]="entidade.id === undefined">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Data:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuarioInsercao?.nome}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Data:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuario?.nome}}</div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
